import { useSelector } from "react-redux";
import { useStoreDispatch } from "../../../store/hooks";
import { useDeleteCustomAuditTemplateMutation, useGetCustomAuditTemplatesQuery } from "../../../store/api/tasks/taskApiSlice";
import { API } from "../../../globals/globals";
import { setOpenToast } from "../../../store/helpers/helperReducers";
import { selectProfilePermissionsSelector } from "../../../store/api/auth/selectors";
import ProfilePermissions from "../../../utils/ProfilePermissions";
import { isTemplateSelector } from "../../../store/api/tasks/selector";
import { extractTemplateDeleteErrorMessage } from "../templateDeleteUtils";

export const useCustomAuditTemplateDisplay = () => {
  const dispatch = useStoreDispatch();
  const selectedTemplate = useSelector(isTemplateSelector);
  const permissions: ProfilePermissions | null = useSelector(selectProfilePermissionsSelector);

  const { data, isLoading, refetch } = useGetCustomAuditTemplatesQuery(undefined, {
    pollingInterval: API.ENDPOINTS.CUSTOM_AUDIT_TEMPLATES.pollingInterval || API.POLLING_INTERVAL,
  });

  const [deleteCustomAuditTemplate] = useDeleteCustomAuditTemplateMutation();

  const handleDeleteTemplate = async (args: any, actionName: string) => {
    let response: any;
    const templateNameForToast = args?.template || args?.templateName || "template";

    try {
      if (!actionName.match("delete")) {
        return;
      }

      const selectedTemplateName = args?.template || args?.templateName;
      const targetTemplate = (data || []).find((item: any) => item.templateName === selectedTemplateName);
      if (!targetTemplate?.id) {
        throw new Error("Template not found.");
      }

      response = await deleteCustomAuditTemplate({ id: targetTemplate.id });
      if (response?.error) {
        throw response.error;
      }

      dispatch(
        setOpenToast({
          openToast: true,
          toastType: "success",
          message: `Template "${templateNameForToast}" deleted successfully`,
        })
      );
      refetch();
    } catch (error: any) {
      dispatch(
        setOpenToast({
          openToast: true,
          toastType: "error",
          message: extractTemplateDeleteErrorMessage(error, templateNameForToast),
        })
      );
    }
  };

  return {
    data: data || [],
    isLoading,
    permissions,
    selectedTemplate,
    handleDeleteTemplate,
  };
};